import { forwardRef } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/generated/IconResizeColumn.tsx
const IconResizeColumn = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	"data-slot": "icon",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ jsx("path", {
		fill: "#998e8e",
		d: "M10.5 15v-2h3v2l4-3-4-3v2h-3V9l-4 3zM19.5 4.8a.8.8 0 0 1 .8-.8h.4a.8.8 0 0 1 .8.8v14.4a.8.8 0 0 1-.8.8h-.4a.8.8 0 0 1-.8-.8zM2.5 4.8a.8.8 0 0 1 .8-.8h.4a.8.8 0 0 1 .8.8v14.4a.8.8 0 0 1-.8.8h-.4a.8.8 0 0 1-.8-.8z"
	})]
});
var IconResizeColumn_default = forwardRef(IconResizeColumn);
//#endregion
export { IconResizeColumn_default as default };
